import { render, staticRenderFns } from "./ProductCombobox.vue?vue&type=template&id=828169a2&scoped=true&"
import script from "./ProductCombobox.vue?vue&type=script&lang=js&"
export * from "./ProductCombobox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "828169a2",
  null
  
)

export default component.exports